import { Container, Heading } from '@troon/ui';
import { PlainDocument, preload } from '../../layouts/plain-document';
import type { RouteDefinition } from '@solidjs/router';

export default function PrivacyPolicy() {
	return (
		<>
			<PlainDocument slug="privacy-policy" />
			<Container size="lg">
				<Heading as="h2">Cookies</Heading>
				<div class="cky-audit-table-element [&>h3]:text-2xl [&>h3]:font-semibold md:[&>h3]:text-3xl"></div>
			</Container>
		</>
	);
}

export const route = { preload: preload('privacy-policy') } satisfies RouteDefinition;
